import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderSCI from './HeaderSCI';
import './controlinterno.css';

const EstructuraCOCODI = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <>
      <HeaderSCI title="ESTRUCTURA DEL COCODI" />

      <div className="container" style={{ paddingBottom: '80px', paddingTop: '40px' }}>
        <div className="row justify-content-center">
          {/* Left Column: Comité de Control Interno */}
          <div className="col-lg-5 col-md-6 col-12 mb-5 d-flex flex-column align-items-center">
            <div className="carpetas-year-header">
              <div className="carpetas-year-icon">
                <i className="fa-regular fa-address-card"></i>
              </div>
              <h4 className="carpetas-year-title" style={{ fontSize: '1.1rem' }}>Comité de Control Interno</h4>
            </div>

            <div className="w-100 d-flex flex-column align-items-center" style={{ maxWidth: '360px' }}>
              <Link 
                to="#" 
                className="carpetas-category-btn" 
                style={{ backgroundColor: '#621132', borderRadius: '25px', padding: '6px 15px' }}
              >
                Organigrama del COCODI
              </Link>
              <Link 
                to="#" 
                className="carpetas-category-btn" 
                style={{ backgroundColor: '#9D2449', borderRadius: '25px', padding: '6px 15px' }}
              >
                Acta de Integración del COCODI
              </Link>
            </div>
          </div>

          {/* Right Column: Enlaces del COCODI */}
          <div className="col-lg-5 col-md-6 col-12 mb-5 d-flex flex-column align-items-center">
            <div className="carpetas-year-header">
              <div className="carpetas-year-icon">
                <i className="fa-regular fa-address-card"></i>
              </div>
              <h4 className="carpetas-year-title" style={{ fontSize: '1.1rem' }}>Enlaces del COCODI</h4>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EstructuraCOCODI;
